interface JaneServiceWorkerOptions {
  /** Logs when events fire, defaults to true */
  debug?: boolean;

  /** Function that fires when the version has been fetched */
  onVersionFetched: (serverVersion: string) => void;

  /** Path to the service worker, defaults to 'sw.js' */
  scriptUrl?: string;

  /** Interval to check for version updates, defaults to 15 mins */
  updateCheckInterval?: number;
}

export const registerJaneServiceWorker = async ({
  debug = true,
  onVersionFetched,
  scriptUrl = 'sw.js',
  updateCheckInterval = 15 * 60 * 1000,
}: JaneServiceWorkerOptions) => {
  if (navigator.serviceWorker) {
    await navigator.serviceWorker.register(scriptUrl, {
      scope: './',
    });

    // check build version on initial load
    navigator.serviceWorker.ready.then((registration) => {
      registration.active?.postMessage({ type: 'LOADED' });
      debug && console.info('[jane service worker] loaded');
    });

    // check the build version every interval, defaults to 15 minutes
    setInterval(() => {
      navigator.serviceWorker.ready.then((registration) => {
        registration.active?.postMessage({ type: 'CHECK_FOR_UPDATES' });
        debug && console.info('[jane service worker] checking for updates');
      });
    }, updateCheckInterval);

    navigator.serviceWorker.addEventListener('message', function (e) {
      if (e.data.type === 'SERVER_VERSION_FETCHED') {
        debug &&
          console.info(
            '[jane service worker] server version fetched',
            e.data.version
          );
        onVersionFetched(e.data.version);
      }
    });
  }
};
